<template>
  <div class="common-panel" v-if="currItem.questions">
    <question-description :currItem="currItem" :code="currItem.topic_type"></question-description>
    <div class="panel-content">
      <!-- 选项 -->
      <div class="panel-content-options">
        <ButtonTool type="play" @click.native="clickPlayTopVoice" v-show="topPlayStatus == 'play'"></ButtonTool>
        <ButtonTool type="pause" @click.native="clickPauseTopVoice" v-show="topPlayStatus == 'pause'"></ButtonTool>
      </div>
      <!-- 套题 -->
      <div class="panel-content-details">
        <div class="question-item" v-for="(item, itemIndex) in filterQuestionList" :key="itemIndex">
          <div class="question-item-stem">
            <div class="stem-index">{{ item.is_example ? $t("hsk_example") : item.index }}.</div>
            <div class="stem-content">
              <img
                v-show="item.playStatus == 'play' || !item.playStatus"
                @click="clickPlayVoice(item, itemIndex)"
                :src="iconPlay('play')"
                alt=""
              />
              <img
                v-show="item.playStatus == 'pause'"
                @click="clickPauseVoice(item, itemIndex)"
                :src="iconPlay('pause')"
                alt=""
              />
            </div>
          </div>
          <div class="question-item-flex">
            <div
              v-for="option in item.answers"
              :key="`${item.index}_${option.index}`"
              :class="[
                'item-answer',
                {
                  selected: option.selected || (item.is_example && option.correct),
                  success: !isExamMode && option.correct,
                  error: !isExamMode && option.selected && !option.correct,
                },
              ]"
              :data-correct="option.correct ? 1 : 0"
              @click="clickQuestionChoice($event, item, option, itemIndex)"
            >
              <div class="item-key">{{ option.flag }}</div>
              <p>{{ option.content }}</p>
            </div>
          </div>

          <div
            class="panel-content-result result-correct"
            v-if="!isExamMode && !item.is_example && item.myAnswerText == item.successAnswerText"
          >
            <p class="correct-tips">
              {{ $t("textbook_chioce_word_text_correct_tip") }}
            </p>
            <div class="correct-box">
              <p class="correct-box-title" v-if="item.audioText">
                {{ $t("hsk_audio_text") }}
              </p>
              <p class="correct-box-answer" v-if="item.audioText">
                {{ item.audioText }}
              </p>
              <div v-show="item.analysisText">
                <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
                <p class="correct-box-answer">
                  {{ item.analysisText }}
                </p>
              </div>
            </div>
          </div>

          <div
            class="panel-content-result result-error"
            v-if="!isExamMode && !item.is_example && item.myAnswerText != item.successAnswerText"
          >
            <p class="error-tips">
              {{ $t("textbook_chioce_word_text_error_tip") }}
            </p>
            <div class="result-show">
              <div class="your-answer">{{ $t("hsk_your_answer") }}{{ item.myAnswerText }}</div>
              <p class="correct-answer">{{ $t("hsk_correct_answer") }}{{ item.successAnswerText }}</p>
            </div>
            <div class="correct-box">
              <p class="correct-box-title" v-if="item.audioText">
                {{ $t("hsk_audio_text") }}
              </p>
              <p class="correct-box-answer" v-if="item.audioText">
                {{ item.audioText }}
              </p>
              <div v-show="item.analysisText">
                <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
                <p class="correct-box-answer">
                  {{ item.analysisText }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PhoneticText from "@/components/ui/phoneticText";
import QuestionDescription from "@/components/hsk/questionDescription";

export default {
  components: {
    PhoneticText,
    QuestionDescription,
  },
  data() {
    return {
      // 试题列表
      items: [],
      // 当前试题Index
      currIndex: 0,
      // 当前试题正确答案
      currCorrectAnswer: [1, 2, 3],
      // 是否已提交
      isSubmit: false,
      // 是否页面事件禁用
      isDisabled: false,
      icons: {
        play: require("@/assets/images/btn_play_hsk.png"),
        pause: require("@/assets/images/btn_pause_hsk.png"),
      },
      changeBtn: false,
      topPlayStatus: "play",
      noAnswerQuesIndex: 0,
    };
  },
  computed: {
    language() {
      let local = localStorage.getItem("language");
      if (local == "zh") {
        return "cn";
      } else {
        return local;
      }
    },
    filterQuestionList() {
      let questionsList = this.currItem.questions;
      let array = [];
      //去除例题
      array = questionsList.filter(function (item) {
        return !item.is_example;
      });
      //根据当前语言显示分析
      array.map((item, index) => {
        item.analysisText = item.analysis[this.language] ? item.analysis[this.language] : item.analysis["cn"];
        item.audioText = item.listen.audio_text;
        if (this.currItem.answer && this.currItem.answer.length > 0 && !this.changeBtn) {
          for (let i = 0; i < item.answers.length; i++) {
            if (item.answers[i].index == this.currItem.answer[index]) {
              item.answers[i].selected = true;
              item.myAnswerText = item.answers[i].flag;
            } else {
              item.answers[i].selected = false;
            }
            if (item.answers[i].correct) {
              item.successAnswerText = item.answers[i].flag;
            }
          }
        }
      });

      this.changeBtn = false;
      return array;
    },
  },
  props: {
    //当前试题项
    currItem: {
      type: Object,
      required: true,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
    baseUrl: {
      type: String,
      default: "",
    },
  },
  watch: {
    // 监听选择了答案直接下一题
    currItem: {
      handler(newVal) {
        console.log("newVal======", newVal);
      },
      deep: true,
    },
  },
  methods: {
    // 小题选项点击事件
    clickQuestionChoice(event, question, option, index) {
      console.log(this.currItem);
      this.stopAllVoice();
      if (question.is_example) {
        return;
      }
      if (!this.isExamMode) {
        return;
      }
      const isCorrect = parseInt(event.currentTarget.dataset.correct);
      let questions = this.currItem.questions.map((item) => {
        // 更新重选的答案
        this.$set(this.currItem.answer, index, option.index.toString());
        if (item.index === question.index) {
          item.playStatus = "play";
          let questionTemp = {
            ...item,
            ansId: option.index, // 学生作答
            isFinished: true, // 标识已作答
            isCorrect, // 标识是否作答成功
          };
          questionTemp.answers = questionTemp.answers.map((item1) => {
            if (item1.index === option.index) {
              return {
                ...item1,
                selected: true,
              };
            } else {
              return {
                ...item1,
                selected: false,
              };
            }
          });

          return questionTemp;
        } else {
          return {
            ...item,
          };
        }
      });

      this.changeBtn = true;
      this.currItem.questions = questions;
      Object.assign(this.currItem.questions, questions);

      // 作答的对象
      let ansObj = {
        questionId: question.index,
        answer: option.index.toString(),
        judge: isCorrect,
        scores: isCorrect == 1 ? question.score : 0,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
        // num: this.currItem.num,
        // nnum: this.currItem.nnum,
      };

      // 选中后延时1ms再提交
      setTimeout(() => {
        this.$emit("saveRes", ansObj);
      });
    },
    //点击播放
    clickPlayVoice(question) {
      this.resetPlayStatus(question, "pause");
      this.topPlayStatus = "play";
      let audioPath = this.baseUrl + question.listen.audio_file;
      console.log("小题播放链接===", audioPath);
      this.$player.play(audioPath);
      this.$player.onended = () => {
        this.resetPlayStatus(question, "play");
      };
    },
    //点击暂停
    clickPauseVoice(question) {
      this.$player.pause();
      this.resetPlayStatus(question, "play");
    },
    //根据状态显示播放/暂停按钮
    iconPlay(playType) {
      return this.icons[playType];
    },
    //重置播放状态
    resetPlayStatus(question, status) {
      let questions = this.currItem.questions.map((item) => {
        if (item.index === question.index) {
          item.playStatus = status;
          console.log(item.playStatus);
          return item;
        } else {
          item.playStatus = "play";
          return {
            ...item,
          };
        }
      });
      this.currItem.questions = questions;
      console.log(questions);
    },
    //存在作答的小题时，自动播放未作答的小题音频
    autoPlay(obj) {
      //判断当前题，若未作答，则自动播放音频
      if (obj.answer && obj.answer.length) {
        // let array = obj.questions.filter(function (item) {
        //   return !item.is_example
        // })

        let noAnswerQuesIndex = obj.questions.findIndex((item) => {
          return item.index == obj.index;
        });

        this.noAnswerQuesIndex = noAnswerQuesIndex;
        if (!obj.answer[noAnswerQuesIndex] && noAnswerQuesIndex == 0) {
          //一个题都没选，则先播放题干音频
          this.clickPlayTopVoice();
        } else if (!obj.answer[noAnswerQuesIndex]) {
          this.clickPlayVoice(obj.questions[noAnswerQuesIndex]);
        }
      }
    },
    //停止全部音频，图标都恢复原来的未播放状态
    stopAllVoice() {
      this.currItem.questions.forEach((question) => {
        question.playStatus = "play";
      });
      this.$player.stop();
    },
    //点击播放嘴顶部录音
    clickPlayTopVoice() {
      this.currItem.questions.forEach((question) => {
        question.playStatus = "play";
      });
      this.topPlayStatus = "pause";
      let audioPath = this.baseUrl + this.currItem.top_listen.audio_file;
      console.log("题干播放链接===", audioPath);
      this.$player.play(audioPath);
      this.$player.onended = () => {
        this.topPlayStatus = "play";
        if (this.noAnswerQuesIndex == 0) {
          this.clickPlayVoice(this.filterQuestionList[0]);
        }
      };
    },
    //点击暂停嘴顶部录音
    clickPauseTopVoice() {
      this.topPlayStatus = "play";
      this.$player.pause();
    },
  },
};
</script>

<style lang="scss" scoped>
.common-panel {
  position: relative;
  .ques-area-des {
    position: absolute;
    left: 29px;
    top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #b5b5be;
    margin-top: 0px;
  }
  .panel-content {
    min-height: 540px;

    // 选项列表
    &-options {
      padding: 30px 30px 30px 30px;
      display: flex;
      justify-content: center;
      .stem-index {
        width: 22px;
        margin-right: 7px;
        color: #c4c9d3;
      }
      .question-options-item {
        width: 195px;
        height: 110px;
        margin-bottom: 20px;
        margin-right: 30px;
        border-radius: 5px;
        position: relative;

        .item-key {
          width: 46px;
          height: 27px;
          line-height: 27px;
          text-align: center;
          color: #ffffff;
          background: rgba(0, 0, 0, 0.6);
          border-radius: 4px 0px 4px 0px;
          position: absolute;
          top: 0px;
          left: 0px;
        }
        .item-content {
          img {
            width: 195px;
            height: 110px;
            border-radius: 5px;
            object-fit: contain;
          }
        }
      }
    }

    // 套题详情
    &-details {
      padding: 0 30px;

      .question-item {
        padding: 20px 0;
        border-top: 1px solid #f2f3f7;
        &-flex {
          width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        &-stem {
          display: flex;
          flex-direction: row;
          align-items: center;

          .stem-index {
            min-width: 22px;
            margin-right: 7px;
            color: #c4c9d3;
          }
          .stem-content {
            img {
              width: 40px;
              height: 40px;
              cursor: pointer;
            }
          }
        }
        .item-answer {
          cursor: pointer;
          position: relative;

          display: flex;
          flex-direction: column;
          justify-content: center;

          padding-left: 40px;
          width: 316px;
          min-height: 39px;
          padding: 10px 10px 10px 40px;
          font-size: 15px;
          margin-top: 10px;

          color: rgba(63, 70, 81, 1);
          background: rgba(242, 243, 247, 1);
          border-radius: 5px;
          box-sizing: border-box;

          .item-key {
            position: absolute;
            font-size: 15px;
            font-weight: 600;
            color: rgba(174, 186, 198, 1);
            top: 10px;
            left: 16px;
          }
          p {
            color: #3e4651;
            font-size: 15px;
          }
          &:after {
            position: absolute;
            content: "";
            width: 16px;
            height: 16px;
            right: -24px;
            top: 50%;
            transform: translateY(-50%);
            background-position: 0 0;
            background-repeat: no-repeat;
            background-size: cover;
          }
          &.selected {
            border: 2px solid #faae56;
            background: #ffffff;
          }
          &.success {
            background: #ffffff; // 设置白色背景
            border: 1px solid rgba(9, 203, 160, 1);
            p {
              color: #09cba0;
            }
          }

          &.error {
            background: #ffffff;
            border: 1px solid #fc5a5a;
            p {
              color: #fc5a5a;
            }
          }
        }
      }
    }

    // 选词填空选项列表
    &-answers {
      margin-top: 30px;
      .list-answers {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }

    // 结果
    &-result {
      padding-top: 20px;

      width: 100%;
      &.result-error,
      &.result-correct {
        p.error-tips {
          font-size: 14px;
          color: #fc5a5a;
          margin-bottom: 20px;
        }
        p.correct-tips {
          font-size: 14px;
          color: rgba(9, 203, 160, 1);
          margin-bottom: 20px;
        }
        .result-show {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
        }
        .your-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          img {
            width: 12px;
            height: 12px;
            margin-left: 20px;
          }
        }
        p.correct-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          margin-left: 45px;
        }
        .correct-box {
          background: #fafafb;
          border-radius: 10px;
          padding: 20px;

          &-title {
            font-size: 14px;
            font-weight: bold;
            color: rgba(63, 70, 81, 1);
            margin-bottom: 10px;
          }
          &-answer {
            font-size: 14px;
            font-weight: 400;
            color: rgba(84, 89, 97, 1);
            line-height: 21px;
            margin-bottom: 10px;
            white-space: pre-line;
          }
        }
      }
    }
  }
}
</style>
